(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lr-instagram"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-lr-direction]');
  if (!button) return;
  const gallery = button.closest('.lr-social').querySelector('.lr-social-grid');
  gallery.scrollBy({left: Number(button.dataset.lrDirection) * gallery.clientWidth * 0.85, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
{
  const marker=document.querySelector('[data-rider-code-search]');
  const url=new URL(window.location.href);
  const raw=(url.searchParams.get('q')||'').trim();
  const code=raw.match(/^(\d{5})[\s\u2010-\u2015-]*(\d{3})$/);
  if(marker&&code){
    const canonical=code[1]+'-'+code[2];
    if(raw!==canonical&&(Number(marker.dataset.resultsCount)===0||/[\s\u2010-\u2015]/.test(raw))){
      url.searchParams.set('q',canonical);
      url.searchParams.set('type','product');
      url.searchParams.set('options[unavailable_products]','show');
      url.searchParams.delete('page');
      window.location.replace(url.href);
    }
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rider-brand-showcase"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rider-brand-showcase'))customElements.define('rider-brand-showcase',class extends HTMLElement{
 connectedCallback(){
  this.tabs=[...this.querySelectorAll('[role=tab]')];this.panels=[...this.querySelectorAll('[role=tabpanel]')];this.index=0;this.timer=null;this.inView=false;this.focused=false;this.manual=matchMedia('(prefers-reduced-motion: reduce)').matches;this.pause=this.querySelector('.rs-showcase__pause');this.abort=new AbortController();const options={signal:this.abort.signal};
  this.choose=(i,manual=false)=>{if(manual)this.manual=true;this.index=(i+this.tabs.length)%this.tabs.length;this.tabs.forEach((t,n)=>{t.setAttribute('aria-selected',String(n===this.index));t.tabIndex=n===this.index?0:-1;this.panels[n].hidden=n!==this.index});if(manual){this.tabs[this.index].focus({preventScroll:true})}this.schedule()};
  this.schedule=()=>{clearTimeout(this.timer);this.pause.setAttribute('aria-pressed',String(this.manual));this.pause.textContent=this.manual?this.dataset.playLabel:this.dataset.pauseLabel;if(!this.manual&&!this.focused&&this.inView&&!document.hidden)this.timer=setTimeout(()=>this.choose(this.index+1),Number(this.dataset.interval)||3000)};
  this.tabs.forEach((t,i)=>{t.addEventListener('click',()=>this.choose(i,true),options);t.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=i+1;if(e.key==='ArrowLeft')n=i-1;if(e.key==='Home')n=0;if(e.key==='End')n=this.tabs.length-1;if(n!==undefined){e.preventDefault();this.choose(n,true)}},options)});
  this.pause.addEventListener('pointerdown',()=>{this.pausePointerPaused=this.manual},options);
  this.pause.addEventListener('pointercancel',()=>{this.pausePointerPaused=undefined},options);
  this.pause.addEventListener('click',e=>{const wasPaused=e.detail>0&&typeof this.pausePointerPaused==='boolean'?this.pausePointerPaused:this.manual;this.pausePointerPaused=undefined;this.manual=!wasPaused;this.focused=false;this.schedule()},options);
  this.addEventListener('focusin',()=>{this.focused=true;this.manual=true;this.schedule()},options);this.addEventListener('focusout',e=>{this.focused=this.contains(e.relatedTarget);this.schedule()},options);
  document.addEventListener('visibilitychange',()=>this.schedule(),options);
  this.observer=new IntersectionObserver(es=>{this.inView=es[0].isIntersecting;this.schedule()},{threshold:.2});this.observer.observe(this);this.schedule();
 }
 disconnectedCallback(){clearTimeout(this.timer);this.observer?.disconnect();this.abort?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-new-arrivals"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.rs-arrivals__track').forEach(track=>{
 if(track.dataset.ready)return;track.dataset.ready='true';
 let paused=false;const reduce=matchMedia('(prefers-reduced-motion: reduce)');
 track.addEventListener('pointerenter',()=>paused=true);track.addEventListener('pointerleave',()=>paused=false);
 track.addEventListener('focusin',()=>paused=true);track.addEventListener('focusout',()=>paused=false);
 const timer=setInterval(()=>{if(!track.isConnected){clearInterval(timer);return}if(paused||reduce.matches||document.hidden)return;
 const item=track.firstElementChild;if(!item)return;
 const max=track.scrollWidth-track.clientWidth;if(max<=1)return;
 track.scrollTo({left:track.scrollLeft>=max-4?0:Math.min(max,track.scrollLeft+item.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:'smooth'});
 },3000);
});

  } catch(e) { console.error(e); }
})();
})();
